import { useCallback, useEffect, useState } from 'react';

import { TableContainer, Table, TableBody } from '@mui/material';
import styled from 'styled-components';

import DashboardTableHead from './DashboardTableHead';
import DashboardTableRow from './DashboardTableRow';
import { getComparator } from '../../../utils/sortingUtils';
import { type DashboardStudentTableColumns, type Order, type StudentMetricsRow } from '../types';
import { useDashboardData } from '../useDashboardData';

const ClassTableContainer = styled(TableContainer)`
    margin-top: 12px;
`;

const DashboardStudentTable: React.FC = () => {
    const { studentMetricsRows } = useDashboardData();
    const [order, setOrder] = useState<Order>('asc');
    const [orderBy, setOrderBy] = useState<DashboardStudentTableColumns>('sortName');
    const [studentRows, setStudentRows] = useState<StudentMetricsRow[]>(studentMetricsRows);

    useEffect(() => {
        if (studentMetricsRows) {
            setStudentRows(studentMetricsRows);
        }
    }, [studentMetricsRows]);

    useEffect(() => {
        setOrderBy('sortName');
    }, []);

    const handleRequestSort = useCallback(
        (event: React.MouseEvent<unknown>, property: DashboardStudentTableColumns) => {
            const sortProperty = property === 'name' ? 'sortName' : property;
            const isAsc = orderBy === property && order === 'asc';

            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(sortProperty);
            setStudentRows(studentRows.slice().sort(getComparator(order, orderBy)));
        },
        [order, orderBy, studentRows]
    );

    const renderTableBody = useCallback(
        () => studentRows.map((row, index) => <DashboardTableRow key={index} row={row} />),
        [studentRows]
    );

    return (
        <ClassTableContainer>
            <Table id="dashboard-user-details-table">
                <DashboardTableHead onRequestSort={handleRequestSort} order={order} orderBy={orderBy} />
                <TableBody>{renderTableBody()}</TableBody>
            </Table>
        </ClassTableContainer>
    );
};

export default DashboardStudentTable;
